import React from "react";
import {
  DialogTitle,
  IconButton,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import BTBox from "../BTBox";
import BTButton from "../BTButton";
import BTDialogboxRoot from "./BTDialogboxRoot";
const BTDialogBox = React.forwardRef(
  (
    {
      children,
      close,
      title,
      width,
      maxHeight,
      minHeight,
      buttons = [],
      onSubmit,
      ...rest
    },
    ref
  ) => {
    return (
      <BTDialogboxRoot {...rest} onClose={close} ownerState={{ width }}>
        <DialogTitle sx={{ m: 0, p: 2 }}>{title}</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={close}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <BTBox
          component={"form"}
          onSubmit={onSubmit}
          noValidate
          autoComplete="off"
        >
          <DialogContent
            ref={ref} // The forwarded ref is attached here
            dividers
            sx={{
              maxHeight: maxHeight || "500px",
              minHeight: minHeight || "200px",
            }}
          >
            {children}
          </DialogContent>
          <DialogActions>
            {buttons.map((button, index) => (
              <BTButton
                key={index}
                size={button.size || "small"}
                variant={button.variant || "contained"}
                color={button.color || "primary"}
                type={button.type || "button"}
                onClick={
                  button.name?.toLowerCase() === "cancel"
                    ? close
                    : button.onClick
                }
                sx={button.sx}
                disabled={button.disabled}
              >
                {button.loading ? button.loadingComponent : button.name}
              </BTButton>
            ))}
          </DialogActions>
        </BTBox>
      </BTDialogboxRoot>
    );
  }
);
BTDialogBox.displayName = "BTDialogBox";
export default BTDialogBox;
